<div id="data-progressbar">
  <p-progressBar
    mode="indeterminate"
    value="0"
    [style.visibility]="reportParamsService._isFetchingData ? 'visible' : 'hidden'"
  >
  </p-progressBar>
</div>

<div id="salesreport-topWrapper">
  <taku-form-list
    #formListReport
    [_hideViewCol]="true"
    [_model]="_model"
    [_hideSavingCtrls]="true"
    [_showCtrlsInEditMode]="false"
    [_rowSelectionType]="RowSelectionType.NONE"
    _title="Daily Sales Report"
    [_hideAddLineHeaderBtn]="true"
    _detailMode="n"
    _scrollHeight="calc(100vh - 30rem)"
    [_hideOptionsHeaderBtn]="false"
    [_hideFilterControls]="false"
    [_modelService]="reportCols"
    [_dataService]="saleReportLocalService"
    [_hideGlobalFilter]="true"
    [_showFooterCurrency]="true"
  >
  </taku-form-list>
</div>
